<template>
  <div class="nx-relation-editor-toolbar-wrapper">
    <v-toolbar flat dense color="transparent">
      <v-toolbar-title>
        {{ title }}
        <v-tooltip top v-if="helpText">
          <v-icon class="ml-1 cursor-pointer" small slot="activator">help_outline</v-icon>
          <span v-html="helpText"></span>
        </v-tooltip>
      </v-toolbar-title>
      <slot name="post-title"></slot>
      <v-spacer></v-spacer>
      <v-btn v-if="bcubeAssistantComponent"
             @click.prevent="$emit('bcube-assistant', { inputName: 'socialNetworkSummary', component: bcubeAssistantComponent })"
             class="mt-0 mx-0 mb-1" icon small>
        <v-icon color="primary" v-text="'tips_and_updates'"></v-icon>
      </v-btn>
      <slot name="actions"></slot>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'nx-relation-editor-toolbar',
  props: {
    title: {
      type: String,
      required: true,
    },
    helpText: {
      type: String,
    },
    bcubeAssistantComponent: {
      type: String,
    },
  },
  computed: {
    inputName() {
      console.log(this.title.split('.').pop());
      return this.title.split('.').pop();
    },
  },
};
</script>

<style lang="stylus">
// base
$toolbar_fgColor = #41414e;
$button_fgColor = #8c8c9c;

// style
.nx-relation-editor-toolbar-wrapper .v-toolbar
  border-width: 0 0 1px
  border-style: solid
  border-color: #bdbdbd !important

  .v-btn .v-btn__content .v-icon
    color: $button_fgColor

  .v-toolbar__content
    padding: 0 !important

  .v-toolbar__title
    color: $toolbar_fgColor
    font-size: 14px
    text-transform: uppercase

</style>
